import {
  MissingTranslationHandler as IMissingTranslationHandler,
  MissingTranslationHandlerParams,
} from "@ngx-translate/core";

export const FALLBACK = Symbol.for("tbo.translate.fallback");

export class FallbackMissingTranslationHandler
  implements IMissingTranslationHandler
{
  handle(params: MissingTranslationHandlerParams) {
    if (
      params.interpolateParams &&
      FALLBACK in params.interpolateParams &&
      typeof params.interpolateParams[FALLBACK] === "string"
    ) {
      return params.translateService.parser.interpolate(
        params.interpolateParams[FALLBACK],
        params.interpolateParams,
      );
    }
    return params.key;
  }
}
